import styled from 'styled-components';

export const BoardContainer = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding-bottom: 10px;
  width: 100%;
  align-items: flex-start;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
`;

export const Column = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  width: 300px;
  min-width: 300px;
  height: calc(100vh - 400px);
  max-height: 700px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const ColumnHeader = styled.div`
  padding: 15px 16px 6px;
  border-radius: 14px 14px 0 0;
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${({ $color }) => $color}15;
  position: relative;
`;

export const ColumnHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const ColumnIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
  border-radius: 10px;
  width: 32px;
  height: 32px;
`;
export const IconStatus = styled.img``;

export const ColumnTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #314158;
  margin: 0;
`;

export const ColumnCount = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ $color }) => $color};
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  text-align: center;
  position: absolute;
  top: 6px;
  left: 37px;
`;

export const CheckBoxBlock = styled.div`
  width: 32px;
  height: 32px;
  background-color: white;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f1f5f9;
  }
`;
export const ColumnCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  cursor: pointer;
  border: 1px solid #0000001a;
  background: #f3f3f5;
  box-shadow: 0px 0.65px 1.3px 0px #0000000d;
  accent-color: #2d6cdf;
  flex-shrink: 0;
  border-radius: 3px;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    border-color: #2d6cdf;
  }

  &:checked {
    background-color: #2d6cdf;
    border-color: #2d6cdf;
  }
  &:checked::after {
    content: '';
    width: 3px;
    height: 7px;
    border: solid white;
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 1px;
    left: 4px;
  }
`;

export const CardsContainer = styled.div`
  padding: 0 18px 16px;
  flex: 1;
  overflow-y: auto;
  background: ${({ $isDraggingOver, $color }) =>
    $isDraggingOver ? `${$color}15` : `${$color}15`};
  transition: background 0.2s ease;
  border-radius: 0 0 14px 14px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const EmptyMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
`;
